import { render, staticRenderFns } from "./TournamentPart.vue?vue&type=template&id=161db2c1&"
import script from "./TournamentPart.vue?vue&type=script&lang=js&"
export * from "./TournamentPart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/betsur.net.ar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('161db2c1')) {
      api.createRecord('161db2c1', component.options)
    } else {
      api.reload('161db2c1', component.options)
    }
    module.hot.accept("./TournamentPart.vue?vue&type=template&id=161db2c1&", function () {
      api.rerender('161db2c1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layout/TournamentPart.vue"
export default component.exports